export default "__VITE_ASSET__CSIZ_tjJ__"